var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99995 5V1.002C6.99995 0.736782 6.8946 0.482429 6.70706 0.294892C6.51952 0.107356 6.26517 0.0019989 5.99995 0.0019989C5.73474 0.0019989 5.48038 0.107356 5.29285 0.294892C5.10531 0.482429 4.99995 0.736782 4.99995 1.002V5H1.00195C0.736737 5 0.482383 5.10536 0.294847 5.29289C0.10731 5.48043 0.00195312 5.73478 0.00195312 6C0.00195312 6.26522 0.10731 6.51957 0.294847 6.70711C0.482383 6.89464 0.736737 7 1.00195 7H4.99995V10.998C4.99995 11.2632 5.10531 11.5176 5.29285 11.7051C5.48038 11.8926 5.73474 11.998 5.99995 11.998C6.26517 11.998 6.51952 11.8926 6.70706 11.7051C6.8946 11.5176 6.99995 11.2632 6.99995 10.998V7H10.998C11.2632 7 11.5175 6.89464 11.7051 6.70711C11.8926 6.51957 11.998 6.26522 11.998 6C11.998 5.73478 11.8926 5.48043 11.7051 5.29289C11.5175 5.10536 11.2632 5 10.998 5H6.99995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddWhite);
export default __webpack_public_path__ + "static/media/ic_add_white.1c7b4a50331166a70e32c662669c99d3.svg";
export { ForwardRef as ReactComponent };